import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const clearAllData = async () => {
  try {
    console.log('🗑️ Starting data cleanup...');
    
    const collections = ['players', 'teams', 'fixtures', 'matches', 'leagues'];
    
    for (const collectionName of collections) {
      const querySnapshot = await getDocs(collection(db, collectionName));
      let deleteCount = 0;
      
      for (const document of querySnapshot.docs) {
        await deleteDoc(doc(db, collectionName, document.id));
        deleteCount++;
      }
      
      console.log(`  ✅ Deleted ${deleteCount} documents from ${collectionName}`);
    }
    
    console.log('✨ Database cleared successfully!');
    return true;
  } catch (error) {
    console.error('❌ Error clearing data:', error);
    throw error;
  }
};
